// Mapping pur entre les details d'acte (modele local) et les entrees
// facfse.Prest (PascalCase). Le discriminant NGAP/CCAM est PrestaCCAM.
// Reference legacy : frmdetailCCAM.vb (DET_ChargementTravail / DET_StockageTravail).

// Listes statiques pour les combos (libelles francais sans accents).
export const QUALIF_DEPENSE = [
    { valeur: '', libelle: '(Aucun)' },
    { valeur: 'D', libelle: 'D - Entente directe' },
    { valeur: 'E', libelle: 'E - Exigence particuliere' },
    { valeur: 'F', libelle: 'F - Deplacement non prescrit' },
    { valeur: 'G', libelle: 'G - Acte gratuit' },
    { valeur: 'N', libelle: 'N - Non remboursable' },
    { valeur: 'A', libelle: 'A - Depassement autorise' },
    { valeur: 'M', libelle: 'M - Depassement maitrise' },
    { valeur: 'B', libelle: 'B - Depassement autorise et entente directe' },
    { valeur: 'C', libelle: 'C - Depassement maitrise et exigence particuliere' },
    { valeur: 'L', libelle: 'L - Prestation soumise a un accord de prise en charge SMG' },
];
// A/M/B/C ne sont valides que si CPS prescripteur (contexte non dispo cote web) -> inclus quand meme, saisie permissive.

export const JUSTIF_NGAP = [
    { valeur: '', libelle: '(Aucun)' },
    { valeur: '0', libelle: "0 - Pas d'exoneration" },
    { valeur: '3', libelle: '3 - Soins particuliers exoneres' },
    { valeur: '4', libelle: '4 - Soins relatifs aux ALD' },
    { valeur: '5', libelle: '5 - Assure ou beneficiaire exonere' },
    { valeur: '6', libelle: '6 - Regimes speciaux (Mines, SNCF)' },
    { valeur: '7', libelle: '7 - Dispositif prevention en maladie' },
    { valeur: '9', libelle: '9 - Fonds National de Solidarite (FSV)' },
];

export const JUSTIF_CCAM = [
    { valeur: '', libelle: '(Aucun)' },
    { valeur: '0', libelle: "0 - Pas d'exoneration" },
    { valeur: '3', libelle: '3 - Soins particuliers exoneres' },
    { valeur: '4', libelle: '4 - Soins relatifs aux ALD' },
    { valeur: '5', libelle: '5 - Assure ou beneficiaire exonere' },
    { valeur: '6', libelle: '6 - Exoneration regimes speciaux' },
    { valeur: '7', libelle: '7 - Soins exoneres dans le cadre d un dispositif de prevention' },
    { valeur: '8', libelle: '8 - Reserve Regime General' },
    { valeur: '9', libelle: '9 - FSV' },
    { valeur: 'C', libelle: "C - Soins exoneres du fait de la nature de l'acte ou du depassement du seuil" },
];

export const COMPLEMENT = [
    { valeur: '', libelle: '(Aucun)' },
    { valeur: 'N', libelle: 'N - Nuit' },
    { valeur: 'F', libelle: 'F - Dimanche Jour ferie' },
    { valeur: 'U', libelle: 'U - Urgence' },
];

export const ENTENTE_PREALABLE = [
    { valeur: '', libelle: '(Aucun)' },
    { valeur: '0', libelle: '0 - Delai passe sans reponse' },
    { valeur: '4', libelle: '4 - Reponse favorable obtenue' },
    { valeur: '5', libelle: "5 - Soins d'urgence manifeste" },
];

export const RE_OPTIONS = [
    { valeur: '', libelle: '(Aucun)' },
    { valeur: 'O', libelle: 'O - Oui' },
    { valeur: 'N', libelle: 'N - Non' },
];

export const SC_OPTIONS = [
    { valeur: '', libelle: '(Aucun)' },
    { valeur: 'C', libelle: 'C - Supplement de charges en cabinet' },
];

// Descripteurs de champs : pilotent le rendu du panneau dans NewFSE.vue.
// type : 'text' | 'date' | 'checkbox' | 'readonly' | 'combo'
// combo : SOIT options (liste statique [{valeur,libelle}]), SOIT dynamique
//         (cle de la reponse getListeChoixCCAM).
// taille : 'xs' | 'sm' | 'md' (dimensionnement du controle).
export const CHAMPS_NGAP = [
    { key: 'complement', label: 'Complement', type: 'combo', options: COMPLEMENT, taille: 'xs' },
    { key: 'qualifDep', label: 'Qualif. depense', type: 'combo', options: QUALIF_DEPENSE, taille: 'xs' },
    { key: 'detailDent', label: 'Dent / Detail', type: 'text', taille: 'sm' },
    { key: 'ep', label: 'Entente prealable', type: 'combo', options: ENTENTE_PREALABLE, taille: 'sm' },
    { key: 'datep', label: 'Date EP', type: 'date', taille: 'md' },
    { key: 'denombrement', label: 'Denombrement', type: 'text', taille: 'xs' },
    { key: 'coefficient', label: 'Coefficient', type: 'readonly', taille: 'xs' },
    { key: 'quantite', label: 'Quantite', type: 'readonly', taille: 'xs' },
    { key: 'codJustif', label: 'Code justif.', type: 'combo', options: JUSTIF_NGAP, taille: 'xs' },
    { key: 'rmo', label: 'RMO', type: 'checkbox', taille: 'xs' },
    { key: 'montantPaye', label: 'Montant', type: 'readonly', taille: 'md' },
    { key: 'baseRemb', label: 'Base remb.', type: 'text', forcable: 'base', taille: 'md' },
    { key: 'tauxRemb', label: 'Taux remb.', type: 'readonly', taille: 'sm' },
];

export const CHAMPS_CCAM = [
    { key: 're', label: 'Remb. exceptionnel', type: 'combo', options: RE_OPTIONS, taille: 'xs' },
    { key: 'sc', label: 'Supplement charge', type: 'combo', options: SC_OPTIONS, taille: 'xs' },
    { key: 'activite', label: 'Activite', type: 'combo', dynamique: 'activites', taille: 'xs' },
    { key: 'phase', label: 'Phase', type: 'combo', dynamique: 'phases', taille: 'xs' },
    { key: 'detailDent', label: 'Dent', type: 'text', taille: 'sm' },
    { key: 'mod1', label: 'Modificateur 1', type: 'combo', dynamique: 'modificateurs1', taille: 'xs' },
    { key: 'mod2', label: 'Modificateur 2', type: 'combo', dynamique: 'modificateurs2', taille: 'xs' },
    { key: 'mod3', label: 'Modificateur 3', type: 'combo', dynamique: 'modificateurs3', taille: 'xs' },
    { key: 'mod4', label: 'Modificateur 4', type: 'combo', dynamique: 'modificateurs4', taille: 'xs' },
    { key: 'codJustif', label: 'Code justif.', type: 'combo', options: JUSTIF_CCAM, taille: 'xs' },
    { key: 'qualifDep', label: 'Qualif. depense', type: 'combo', options: QUALIF_DEPENSE, taille: 'xs' },
    { key: 'ep', label: 'Entente prealable', type: 'combo', options: ENTENTE_PREALABLE, taille: 'sm' },
    { key: 'datep', label: 'Date EP', type: 'date', taille: 'md' },
    { key: 'prixUnitaire', label: 'Prix unitaire', type: 'text', forcable: 'prix', taille: 'md' },
    { key: 'montantPaye', label: 'Montant', type: 'text', forcable: 'montant', taille: 'md' },
    { key: 'baseRemb', label: 'Base remb.', type: 'text', forcable: 'base', taille: 'md' },
    { key: 'tauxRemb', label: 'Taux remb.', type: 'readonly', taille: 'sm' },
    { key: 'regroupement', label: 'Regroupement', type: 'combo', dynamique: 'regroupements', taille: 'md' },
    { key: 'association', label: 'Code association', type: 'combo', dynamique: 'associations', taille: 'sm' },
];

function s(v) { return v == null ? '' : String(v).trim(); }
function n(v) { const x = parseFloat(String(v).replace(',', '.')); return isNaN(x) ? 0 : x; }

export function detailVide(type) {
    const champs = type === 'CCAM' ? CHAMPS_CCAM : CHAMPS_NGAP;
    const d = {};
    for (const c of champs) d[c.key] = c.type === 'checkbox' ? false : '';
    d.force = { base: false, montant: false, prix: false };
    return d;
}

// Type d'une entree Prest : CCAM si PrestaCCAM, sinon NGAP.
export function typeDepuisPrest(p) { return p && p.PrestaCCAM ? 'CCAM' : 'NGAP'; }
// Code acte d'une entree Prest (Actedetail pour CCAM, Presta_Renamed pour NGAP).
export function codeDepuisPrest(p) {
    if (!p) return '';
    return typeDepuisPrest(p) === 'CCAM' ? s(p.Actedetail) : s(p.Presta_Renamed);
}

// Lecture : entree Prest (PascalCase) -> objet detail (forme NGAP ou CCAM selon PrestaCCAM).
export function detailDepuisPrest(p) {
    const type = typeDepuisPrest(p);
    const d = detailVide(type);
    if (!p) return d;
    const f = Array.isArray(p.Donneeforcee) ? p.Donneeforcee : [];
    d.force = { montant: !!f[1], base: !!f[2], prix: !!f[3] };
    if (type === 'CCAM') {
        d.re = s(p.RemboursementexceptionnelCCAM);
        d.sc = s(p.SupplementchargeCCAM);
        d.activite = s(p.ActiviteCCAM);
        d.phase = s(p.PhasetraitementCCAM);
        d.detailDent = s(p.Detaildent);
        const mods = (p.ModCCAM && Array.isArray(p.ModCCAM.ModAMO)) ? p.ModCCAM.ModAMO : [];
        d.mod1 = s(mods[1]); d.mod2 = s(mods[2]); d.mod3 = s(mods[3]); d.mod4 = s(mods[4]);
        d.codJustif = s(p.CodjustifCCAM);
        d.qualifDep = s(p.Qualifdep);
        d.ep = s(p.Ep);
        d.datep = s(p.Datep);
        d.prixUnitaire = n(p.Prixunitaire);
        d.montantPaye = n(p.Montantpaye);
        d.baseRemb = n(p.Baseremb);
        d.tauxRemb = n(p.Tauxremb);
        d.regroupement = s(p.RegroupementCCAM);
        d.association = s(p.AssociationCCAM);
    } else {
        d.complement = s(p.Complementp);
        d.qualifDep = s(p.Qualifdep);
        d.detailDent = s(p.Detaildent);
        d.ep = s(p.Ep);
        d.datep = s(p.Datep);
        d.denombrement = s(p.Denombrement);
        d.coefficient = s(p.Coefficient);
        d.quantite = s(p.Quantite);
        d.codJustif = (Number(p.Codjustif) === 999) ? 'R' : s(p.Codjustif);
        d.rmo = s(p.Rmo) === 'R';
        d.montantPaye = n(p.Montantpaye);
        d.baseRemb = n(p.Baseremb);
        d.tauxRemb = n(p.Tauxremb);
    }
    return d;
}

// Ecriture : objet detail -> entree Prest (mutation directe, PascalCase).
// Les champs readonly (taux, coefficient, quantite) ne sont pas reecrits.
// Les montants/base/PU ne sont reecrits que s'ils sont forces (Donneeforcee).
export function appliquerDetailDansPrest(p, d) {
    if (!p || !d) return;
    const type = p.PrestaCCAM ? 'CCAM' : 'NGAP';
    if (!Array.isArray(p.Donneeforcee)) p.Donneeforcee = [false, false, false, false, false, false];
    const force = d.force || {};
    if (type === 'CCAM') {
        p.RemboursementexceptionnelCCAM = s(d.re);
        p.SupplementchargeCCAM = s(d.sc);
        p.ActiviteCCAM = s(d.activite);
        p.PhasetraitementCCAM = s(d.phase);
        p.Detaildent = s(d.detailDent);
        if (!p.ModCCAM) p.ModCCAM = { ModAMO: [], ModAMC: [] };
        if (!Array.isArray(p.ModCCAM.ModAMO)) p.ModCCAM.ModAMO = [];
        p.ModCCAM.ModAMO[1] = s(d.mod1);
        p.ModCCAM.ModAMO[2] = s(d.mod2);
        p.ModCCAM.ModAMO[3] = s(d.mod3);
        p.ModCCAM.ModAMO[4] = s(d.mod4);
        p.CodjustifCCAM = s(d.codJustif);
        p.Qualifdep = s(d.qualifDep);
        p.Ep = s(d.ep);
        p.Datep = s(d.datep);
        p.RegroupementCCAM = s(d.regroupement);
        p.AssociationCCAM = s(d.association);
        p.Donneeforcee[1] = !!force.montant;
        p.Donneeforcee[2] = !!force.base;
        p.Donneeforcee[3] = !!force.prix;
        if (force.montant) p.Montantpaye = n(d.montantPaye);
        if (force.base) p.Baseremb = n(d.baseRemb);
        if (force.prix) p.Prixunitaire = n(d.prixUnitaire);
    } else {
        p.Complementp = s(d.complement);
        p.Qualifdep = s(d.qualifDep);
        p.Detaildent = s(d.detailDent);
        p.Ep = s(d.ep);
        p.Datep = s(d.datep);
        p.Denombrement = n(d.denombrement);
        p.Codjustif = (s(d.codJustif) === 'R') ? 999 : n(d.codJustif);
        p.Rmo = d.rmo ? 'R' : '';
        p.Donneeforcee[2] = !!force.base;
        if (force.base) p.Baseremb = n(d.baseRemb);
    }
}
